import { localizeHref } from 'modules/locale/history';
import type { URLDescriptor } from 'navi';
import type { HTMLAttributes } from 'react';

import type { ButtonType } from './Button/helpers';

import { ScLink } from './Button/styled';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  target?: string;
  href?: string | null;
  to?: string | Partial<URLDescriptor>;
  disabled?: boolean;
  pending?: boolean;
  onLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  buttonType?: ButtonType;
}

export const handleLinkWrapping = (
  Component: React.ComponentType<any>,
  props: ButtonProps
) => {
  const { href, to, target, children, disabled, onLinkClick, ...rest } = props;

  const button = (
    <Component disabled={disabled || rest.pending} {...rest}>
      {children}
    </Component>
  );

  if (href)
    return (
      <a
        className="button-link"
        href={localizeHref(href)}
        rel={target ? undefined : 'noopener noreferrer'}
        target={target || '_blank'}
      >
        {button}
      </a>
    );

  if (to)
    return (
      <ScLink href={to} onClick={onLinkClick}>
        {button}
      </ScLink>
    );

  return button;
};
